import { apiGet, apiPost, apiPatch, apiDelete } from './client';

export interface WebAnalyticsSite {
  id: number;
  hostname: string;
  productName: string;
  canonicalStreamId: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateWebAnalyticsSiteInput {
  hostname: string;
  productName: string;
  canonicalStreamId: string | null;
}

export interface UpdateWebAnalyticsSiteInput {
  productName?: string;
  canonicalStreamId?: string | null;
  active?: boolean;
}

// Web Analytics Sites registry (Admin) — backend CRUD from plan 85-03.
// Update route is PATCH server-side (backend/src/api/routes/webAnalyticsSiteAdmin.ts);
// apiPatch is used here to match the backend verb exactly.
export async function getWebAnalyticsSites(): Promise<WebAnalyticsSite[]> {
  const res = await apiGet<{ data: WebAnalyticsSite[] }>('/admin/web-analytics-sites');
  return res.data;
}

export async function createWebAnalyticsSite(
  input: CreateWebAnalyticsSiteInput,
): Promise<WebAnalyticsSite> {
  const res = await apiPost<{ data: WebAnalyticsSite }>('/admin/web-analytics-sites', input);
  return res.data;
}

export async function updateWebAnalyticsSite(
  id: number,
  input: UpdateWebAnalyticsSiteInput,
): Promise<WebAnalyticsSite> {
  const res = await apiPatch<{ data: WebAnalyticsSite }>(`/admin/web-analytics-sites/${id}`, input);
  return res.data;
}

export async function deactivateWebAnalyticsSite(id: number): Promise<void> {
  await apiDelete<{ data: { success: boolean } }>(`/admin/web-analytics-sites/${id}`);
}
